import type {MatrixParamBuildParameter} from './MatrixParamBuild.types'

export const errorMessageNotValideParameter =
  'Parameter names must start with an ASCII letter and can contain only [a-zA-Z0-9._-*]'
export const errorMessageNotEmptyParameter = 'Parameter name must not be empty'
export const errorMessageParameterUsed = 'Duplicate parameter name'
export const errorMessageParameterValueUsed = 'Value must be unique'
export const defaultMatrixBuildParameter: MatrixParamBuildParameter = {
  name: '',
  value: [
    {
      value: '',
    },
  ],
}
